import { gql } from "@apollo/client";

export const AVAILABLE_DROPOFF_TIMES = gql`
  query availableTimesForDropOffV2($data: AvailableTimesInputV2!) {
    availableTimesForDropOffV2(
      data: $data
    ) {
      daysMonth {
        date,
        day,
        month,
        year,
        available,
        isNearestAvailableDay,
      },
      appointmentCreateType,
      availableTimes {
        date,
        times {
          time,
          resourcesId,
        },
        appointmentTypes {
          appointmentType,
          petId,
        }
      },
      location {
        idLocation,
        locationName,
        address,
        city,
        position {
          lat,
          lng,
        },
        email,
        phoneNumber,
        background,
      },
      timeZone,
      success,
      messages
    }
  }
`;
